/**
 * Fixed Progress Navigation
 *
 * @package elder-research
 */

export default function() {
	const debug = false;
	if (debug) console.log('Fixed Progress Navigation v1.6');

	const content = document.querySelector('main#content');
	const scrollSpyNav = document.getElementById('scrollspy-nav');
	const header = document.getElementById('header');
	const heroVideo = document.querySelector('.hero-homepage__video'); // Reference to the hero video
	const heroContainer = document.querySelector('.hero-homepage__container'); // Reference to hero container

	if (!content || !scrollSpyNav || !header) {
		if (debug) {
			console.warn('Fixed Progress Navigation: Required elements missing:', {
				contentExists: !!content,
				scrollSpyNavExists: !!scrollSpyNav,
				headerExists: !!header,
			});
		}
		return;
	}

	const sections = Array.from(content.children).filter(child => {
		if (!child) return false;
		if (child.hasAttribute('data-rellax-speed')) return false;
		return !child.classList.contains('line');
	});

	if (!sections.length) {
		if (debug) console.warn('Fixed Progress Navigation: No valid sections found.');
		return;
	}

	sections.forEach((section, index) => {
		if (!section) return;

		const sectionId = `section-${index + 1}`;
		section.setAttribute('id', sectionId);

		if (index < 5) {
			const btn = document.createElement('button');
			btn.textContent = index + 1;
			btn.setAttribute('data-target', sectionId);
			scrollSpyNav.appendChild(btn);

			btn.addEventListener('click', () => {
				const targetSection = document.getElementById(sectionId);
				if (!targetSection) {
					if (debug) console.warn(`Fixed Progress Navigation: Target section #${sectionId} not found.`);
					return;
				}

				// 🔐 Bypass hero scroll lock logic
				window._heroScrollBypass = true;
				setTimeout(() => {
					window._heroScrollBypass = false;
				}, 1000);

				// Reset video to mode-1 state if clicking on section-1
				if (index === 0 && heroVideo && heroContainer) {
					// Reset the hero container mode
					heroContainer.setAttribute('data-mode', 'mode-1');
					
					// Clear all inline styles from the video
					heroVideo.removeAttribute('style');
					
					// Set only opacity to 1
					heroVideo.style.opacity = '1';
					
					// Also reset the iframe if it exists
					const iframe = heroVideo.querySelector('iframe');
					if (iframe) {
						iframe.removeAttribute('style');
					}
					
					// Reset any spacer element
					const spacer = document.querySelector('.hero-homepage__spacer');
					if (spacer) {
						spacer.removeAttribute('style');
					}
					
					// Reset any content margin
					const heroContent = document.querySelector('.hero-homepage__content');
					if (heroContent) {
						heroContent.removeAttribute('style');
						heroContent.style.opacity = '1';
						// Set margin top based on video height plus 20px
						if (heroVideo) {
							const videoHeight = heroVideo.offsetHeight || 0;
							heroContent.style.marginTop = `${videoHeight + 20}px`;
						} else {
							heroContent.style.marginTop = '';
						}
					}
				}

				const isMobile = window.innerWidth <= 1023;
				const extraOffset = 48;
				// Add extra offset for sections 1-5 on desktop
				const desktopExtraOffset = (!isMobile && (index >= 1 && index <= 4)) ? 150 : 0;
				const headerHeight = isMobile ? header.offsetHeight + extraOffset : desktopExtraOffset;

				console.log('index = ' + index);
				console.log('desktopExtraOffset = ' + desktopExtraOffset);

				if (index === 0) {
					window.scrollTo({
						top: 0,
						behavior: 'smooth'
					});
				} else {
					const sectionTop = targetSection.getBoundingClientRect().top + window.scrollY;
					window.scrollTo({
						top: sectionTop - headerHeight,
						behavior: 'smooth'
					});
				}
			});
		}
	});

	const isMobile = window.innerWidth <= 1023;
	const observerOptions = {
		root: null,
		rootMargin: isMobile ? '-50% 0px -50% 0px' : '-20% 0px -80% 0px',
		threshold: 0
	};

	const observer = new IntersectionObserver((entries) => {
		entries.forEach(entry => {
			const id = entry.target.getAttribute('id');
			if (!id) return;

			const btn = scrollSpyNav.querySelector(`[data-target="${id}"]`);
			if (!btn) return;

			if (entry.isIntersecting) {
				scrollSpyNav.querySelectorAll('button').forEach(button => button.classList.remove('--in-view'));
				btn.classList.add('--in-view');
			}
		});
	}, observerOptions);

	sections.forEach(section => {
		if (section) observer.observe(section);
	});
}
